import { atom } from 'recoil';
export const profileInfoState = atom({
    key: 'profileInfoState',
    default: {
        isLoading: false,
        isFormInvalid: true,
        name: '',
        nameError: '',
        mainError: '',
        address: '',
        addressError: '',
        addressLine2: '',
        addressLine2Error: '',
        stateError: '',
        zip: '',
        zipError: '',
        dirtyFields: { name: false, address: false, addressLine2: false, state: false, zip: false },
        idClient: 0,
        logoS3Path: null,
        modalUpdateLogo: false,
        logo: null,
        cashoutActive: false,
        cityError: '',
        idUser: 0,
        firstName: '',
        lastName: '',
        phoneNumber: '',
        phoneExt: '',
        firstNameError: '',
        lastNameError: '',
        phoneNumberError: '',
        titleError: '',
        title: null,
        emailError: '',
        plan: '',
        idCountry: null,
        idCity: null,
        idState: null
    }
});
